import React from "react";

const Candle = ({ className = "" }) => {
  return (
    <span className={`candle ${className}`} aria-hidden="true">
      <span className="candle__glow" />
      <span className="candle__flame" />
      <span className="candle__wick" />
      <span className="candle__body" />
    </span>
  );
};

export default Candle;
